import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNotaProfessor = (): TabelaColuna => ({
  Chave: 'notaProfessor',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 110 }}>Nota</div>
})
